// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource-yaml .yaml-editor{min-height:200px}.resource-yaml footer .actions{text-align:right}", ""]);
// Exports
module.exports = exports;
